import { ListTodo } from 'lucide-react'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@atrvd/saas-ui'

interface ManageProjectionsButtonProps {
  facilityName: string
  rowLabel: string
  periodLabel: string
  onClick: () => void
}

/**
 * The "Manage projections" icon of a facility cell. Its accessible name carries facility, row
 * and period, since the report shows many of them.
 */
export function ManageProjectionsButton({ facilityName, rowLabel, periodLabel, onClick }: ManageProjectionsButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={onClick}
          aria-label={`Manage projections — ${facilityName}, ${rowLabel}, ${periodLabel}`}
          className="h-6 w-6 shrink-0"
        >
          <ListTodo className="h-3.5 w-3.5" aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">Manage projections</TooltipContent>
    </Tooltip>
  )
}
